import Vue from "vue";

import FltlId from "./fltl-id.vue";
import FltlAction from "./fltl-action.vue";
import FltlPriority from "./fltl-priority.vue";
import FltlHaz from "./fltl-haz.vue";
import FltlBols from "./fltl-bols.vue";
import FltlCustomers from "./fltl-customers.vue";
import FltlLfd from "./fltl-lfd.vue";
import FltlAr from "./fltl-ar.vue";
import FltlAp from "./fltl-ap.vue";
import FltlProfit from "./fltl-profit.vue";
import FltlDispatchComment from "./fltl-dispatch-comment.vue";
import FltlTasks from "./fltl-tasks.vue";
import FltlInstructions from "./instructions.vue";

Vue.component("fltl-id", FltlId);
Vue.component("fltl-action", FltlAction);
Vue.component("fltl-priority", FltlPriority);
Vue.component("fltl-haz", FltlHaz);
Vue.component("fltl-bols", FltlBols);
Vue.component("fltl-customers", FltlCustomers);
Vue.component("fltl-lfd", FltlLfd);
Vue.component("fltl-ar", FltlAr);
Vue.component("fltl-ap", FltlAp);
Vue.component("fltl-profit", FltlProfit);
Vue.component("fltl-dispatch-comment", FltlDispatchComment);
Vue.component("fltl-tasks", FltlTasks);
Vue.component("fltl-instructions", FltlInstructions);
